<!-- /* [NT-APPLY-POP] 매칭신청하기 */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="handleToggleModal"
      title="매칭 신청하기"
      v-if="data"
    >
      <div class="popupViewProfile" style="padding-bottom: 60px;">
        <UserInfoCard :data="data" />

        <div>
          <h4 style="color: #26336A; padding-top: 4rem;">매칭 신청하기</h4>

          <div
            style="padding-top: 3rem; display: flex; flex-direction: column; gap: 2rem;"
          >
            <div class="itemRow" style="background-color: #F3F7FB;">
              <figure>
                <img src="/images/myPage/people3.svg" alt="미국 국기" />
              </figure>

              <div class="itemRowText">
                <h3 style="color: #26336A;">개인에게 직접 매칭 신청하기</h3>
                <h6 style="color: #444444;">
                  개인에게 직접 매칭을 신청합니다. <br />
                  NAP의 자문은 구할 수 없으며, 해당 기업과의 직접적인 연결이
                  가능합니다.
                </h6>
              </div>
              <MainButton btnText="신청서 작성" @click="onApply(data)" />
            </div>

            <div class="itemRow" style="background-color: #F4FFF5;">
              <figure>
                <img src="/images/myPage/people4.svg" alt="미국 국기" />
              </figure>

              <div class="itemRowText">
                <h3 style="color: #26336A;">AgeTech Platform의 자문받기</h3>
                <h6 style="color: #444444;">
                  AgeTech Platform의 자문을 받고 매칭을 신청합니다. <br />
                  해당 기업과의 매칭 적절성 또는 다른 기업 추천 등의 피드백을
                  받아볼 수 있습니다.
                </h6>
              </div>
              <MainButton
                btnText="자문 신청"
                color="green"
                @click="onRequest(data)"
              />
            </div>
          </div>
        </div>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "PopupApplyForMatching",
  components: { BasicModal, MainButton, UserInfoCard },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    onApply: Function,
    onRequest: Function,
    data: Object,
  },
  data() {
    return {};
  },
  methods: {
    // onClickSubmitForm() { }
  },
};
</script>

<style lang="scss" scoped>
.itemRow {
  display: flex;
  align-items: flex-end;
  border: 1px solid #ababab;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .itemRowText {
    padding-left: 16px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }
}
</style>
